import ReportContainer from '@/src/components/reports/ReportContainer';
import React from 'react';

export const ReportsPage: React.FC = () => {
  return <ReportContainer />;
};
